/**
 * Imports
*/
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.min.css';

import './tpl.view.scss';

// utils
import lang from '../../misc/i18n.js';
import InstabergUtils from '../../misc/utils.js';
import FullScreenButton from '../../misc/FullScreenButton.js';

/**
 * WordPress dependencies
*/
const { __, _n, sprintf } = wp.i18n;
const { Component, render, findDOMNode, Fragment } = wp.element;

/**
 * Config
*/
const localizationName = 'instaberg';
const alias = 'AAInstaberg-View-';



/**
 * React Components
*/
class InstabergViewPlaylist_PlSingleItem extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isHovered: false,
    };
  }

  render()
  {
    

    let { isHovered } = this.state;
    let isHoveredCss = isHovered ? `${alias}hover-state` : '';
    let isActiveCss = this.props.isActive ? `${alias}video-list-active` : '';

    const { video } = this.props;
    let { image, total_comments, total_likes, caption, link, post_type, username, user_pic, user_fullname, thumb, tags } = video;

    const styleGridImg = {
      backgroundImage: `url(${image})`,
    };

    total_likes = 'undefined' === typeof total_likes ? 0 : total_likes;
    total_likes = InstabergUtils.humanFormat( total_likes );

    total_comments = 'undefined' === typeof total_comments ? 0 : total_comments;
    total_comments = InstabergUtils.humanFormat( total_comments );

    thumb = '' !== thumb ? thumb : image;

    let user_link = '' !== username ? `https://www.instagram.com/${username}/` : '';

    let tags_ = Array.isArray( tags ) && tags.length ? '#' + tags.slice(0, 2).join(', #') : '';

    return (
      <li
        className={ `${isHoveredCss} ${isActiveCss}` }
        data-key={ video.id }
        data-videoid={ video.id }
        onClick={ (e) => { this.onClick( e ) } }
      >

        <div className={ `${alias}video-list-border` }></div>

        <a href="#" className={ `${alias}video-url` }></a>

        <h4 className={ `${alias}video-list-title` }>
          <a href="#"  style={{ color: this.props.pcstyle.background, fontFamily: this.props.pcstyle.fontFamily }}>{ tags_ }</a>
        </h4>

        <span className={ `${alias}video-list-misc` }>
          <span className={ `${alias}video-author` }>
            <a href={ user_link } target="_blank" style={{ color: this.props.pcstyle.color, fontFamily: this.props.pcstyle.fontFamily }}>{ username }</a>
          </span>

        </span>
        <a href="#"><span className={ `${alias}video-list-shadow` }></span></a>

        <div className={ `${alias}video-list-content` }>
          <a href="#">
            { '' !== image ? <img src={ image } /> : '' }
          </a>
        </div>

      </li>
    );
  }

  handleMenuHover( event )
  {
    this.setState({
      isHovered: ! this.state.isHovered
    });
  }

  onClick( event )
  {
    this.props.onClick( event );
  }
}

class InstabergViewPlaylist extends Component {

  constructor(props) {
    super(props);

    this.state = {
      // player
      videobox_isHovered: false,
      fullscreen: false,

      paused: this._get_option('playlistAutoplay') ? false : true,
      muted: false,

      duration: null,
      currentTime: null,

      volume: 0.3,
      volumeOpenBtn: false,
      volumeOpenBox: false,
    }

    this.player_id = InstabergUtils.makeid(25);

    this.listItemHeight = 196;
    this.play_timer = null;
    this.theSimpleBar = null;
    this.scrollElement = null;
  }

  render()
  {
    return ( this.PrintVideosList() );
  }

  componentDidMount()
  {
    if ( ! this._has_videos() ) {
      return false;
    }

    if ( this._get_option('playlistAutoplay') ) {
      document.getElementById( this.player_id ).play();
    }

    this.setVideoTime( 'duration' );
    this.setVideoTime( 'currentTime' );

    if ( this._has_videos() > 1 && this._get_option('playlistShowList') ) {
      this.theSimpleBar = new SimpleBar( document.getElementById( `${this.player_id}simplebar` ), {
        autoHide: true,
        scrollbarMinSize: 50,
      });
      this.scrollElement = this.theSimpleBar.getScrollElement();

      if ( this.props.extra.from_lightbox && this.scrollElement ) {
        this.scrollElement.scrollTop = this._calcListOffset_lbx();
      }
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot)
  {
    if ( this.props.extra.current_videoid !== prevProps.extra.current_videoid ) {

      this.setVideoTime( 'duration' );
      this.setVideoTime( 'currentTime' );
    }

    if ( this.props.extra.from_lightbox && this.scrollElement ) {
      this.scrollElement.scrollTop = this._calcListOffset_lbx();
    }
  }

  setVideoTime( what )
  {
    let self = this;

    let cc = 0,
        max_steps = 200;

    let _do = function() {
      let _timer = setTimeout( () => {

        let _func2call = '_player_get_' + what,
            _valnow = self[ _func2call ]();

        cc++;

        if ( ! Number.isInteger( parseInt( _valnow ) ) && ( cc < max_steps ) ) {
          _do();
        }
        else {
          clearTimeout( _timer );
          _timer = null;
        }
      }, 10 );
    }
    _do();
  }

  PrintVideosList()
  {
    const { current_videoid } = this.props.extra;

    const { layoutType } = this.props.options;
    let videos = this._get_videos();

    if ( ! videos.length ) {
      return '';
    }

    const video_list = videos.map( video => {
      return ( this.PlSingleItem_Print( video ) );
    });

    const current_videoinfo = this.PlayerPrint( current_videoid );

    let class_css = [];
    this._has_videos() <= 1 || ! this._get_option('playlistShowList') ? class_css.push('playlist-hide') : '';
    class_css = class_css.join(' ');

    const video_height = this._get_option('primaryColor')['video_width'];

    return (
      <React.Fragment>
        <div
          className={ `${alias}video-wrapper ${class_css}` }
          style={{ height: video_height }}
        >

          {/* Current Video Played */}
          <ul
            className={ `${alias}video-content` }
            onMouseEnter={ (e) => { this._videobox_handleHover( e ) } }
            onMouseLeave={ (e) => { this._videobox_handleHover( e ) } }
          >
            <li className={ `${alias}video-content-list` }>
              { current_videoinfo }
            </li>
          </ul>
          {/* end Current Video Played */}

          {/* Playlist Items */}
          { this._has_videos() > 1 && this._get_option('playlistShowList')
            ?
              <div
                id={ `${this.player_id}simplebar` }
                className={ `${alias}video-list` }
                style={{ height: video_height }}
              >
                <ul>
                  { video_list }
                </ul>
              </div>
            : ''
          }
          {/* end Playlist Items */}

        </div>
      </React.Fragment>
    );
  }

  //============================================================================================
  // Playlist Items
  PlSingleItem_Print( video )
  {
    const { current_videoid } = this.props.extra;
    
    let pcstyle = {
      color: this._get_option('primaryColor')['text_color'],
      fontFamily: this._get_option('primaryColor')['font_family'],
      fontSize: `${this._get_option('primaryColor')['font_size']}px`,
      background: this._get_option('primaryColor')['main_color'],
    };

    return (
      <InstabergViewPlaylist_PlSingleItem
        pcstyle={ pcstyle }
        video={ video }
        isActive={ current_videoid === video.id ? true : false }
        onClick={ (e) => this.PlSingleItem_onClick(e) }
      />
    );
  }

  PlSingleItem_onClick( event )
  {
    event.preventDefault();
    let videoid = event.currentTarget.dataset.videoid;

    this.setVideoTime( 'duration' );
    this.setVideoTime( 'currentTime' );

    this.setState({
      paused: true,
    });
    clearInterval( this.play_timer );
    this.props.PlSingleItem_onClick( { videoid } );
  }

  //============================================================================================
  // Video Player
  PlayerPrint( videoid )
  {
    let video = this._get_video_info_byid( videoid );

    let { image, total_comments, total_likes, caption, link, post_type, username, user_pic, user_fullname, thumb, tags, video_url } = video;

    const styleGridImg = {
      backgroundImage: `url(${image})`,
    };

    total_likes = 'undefined' === typeof total_likes ? 0 : total_likes;
    total_likes = InstabergUtils.humanFormat( total_likes );

    total_comments = 'undefined' === typeof total_comments ? 0 : total_comments;
    total_comments = InstabergUtils.humanFormat( total_comments );

    thumb = '' !== thumb ? thumb : image;

    let user_link = '' !== username ? `https://www.instagram.com/${username}/` : '';

    let tags_ = Array.isArray( tags ) && tags.length ? '#' + tags.slice(0, 2).join(', #') : '';

    let { duration, currentTime, volume, videobox_isHovered, fullscreen } = this.state;

    let videocontrols_css = [];
    videobox_isHovered ? videocontrols_css.push('show') : '';
    fullscreen ? videocontrols_css.push('isFullscreen') : '';
    videocontrols_css = videocontrols_css.join(' ');

    let pcstyle = {
      color: this._get_option('primaryColor')['text_color'],
      fontFamily: this._get_option('primaryColor')['font_family'],
      fontSize: `${this._get_option('primaryColor')['font_size']}px`,
      background: this._get_option('primaryColor')['main_color'],
      height: `${this._get_option('primaryColor')['video_width']}`
    };


    return (
      <React.Fragment>

        {/* Video Inner */}
        <div className={ `${alias}video-inner` } style={{ height: `${pcstyle.height-140}px` }}>

          {/* Video Top Content */}
          <div className={ `${alias}video-top-content` }>

            <h2 className={ `${alias}video-title` }>
              { tags_ }
            </h2>

            <span className={ `${alias}video-misc` }>
              <span className={ `${alias}video-author` }>
                <a href={ user_link } target="_blank">
                  <img src={ user_pic } alt={ user_fullname } />
                  <span className={ `${alias}video-username` } style={{color: pcstyle.color, fontFamily: pcstyle.fontFamily, fontSize: pcstyle.fontSize }}> { username }  </span>
                </a>
              </span>
            </span>

          </div>
          {/* end Video Top Content */}

          {/* Video Bottom Content */}
          <div className={ `${alias}video-bottom-content` }>

            <span className={ `${alias}video-views-comments` }>
              <span className={ `${alias}video-views` } style={{fontFamily: pcstyle.fontFamily, fontSize: pcstyle.fontSize }}>{ `${total_likes} ${ __('views', localizationName ) }` }</span>
              <span className={ `${alias}video-comments` } style={{fontFamily: pcstyle.fontFamily, fontSize: pcstyle.fontSize }}>{ `${total_comments} ${ __('comments', localizationName ) }` }</span>
            </span>

            <span className={ `${alias}video-icons` }> </span>

          </div>
          {/* end Video Bottom Content */}

        </div>
        {/* end Video Inner */}



        <div className={ `${alias}videocontrols ` }>


            <button className={ `${alias}video-browse` }>
              <span style={{fontFamily: pcstyle.fontFamily, fontSize: pcstyle.fontSize }} onClick={ ( e ) => { window.location = user_link; } }>  Browse  </span>
            </button>

            <div className={ `${alias}videocontrols-line1` }>
                <div className={ `${alias}videocontrols-extrabtns` }>
                  {
                    ( this.state.volumeOpenBtn || this.state.volumeOpenBox ) &&
                    (
                      <div className={ `${alias}rangebar btn-volume-seekbar` }>
                        <input type='range'
                          type='range'
                          value={ volume }
                          min={ 0 }
                          max={ 1 }
                          step={ 0.05 }
                          onChange={ ( e ) => { this._player_customVolume( e ) } }
                          onMouseEnter={ (e) => { this._player_volume_onMouseEnter( e, 'Box' ) } }
                          onMouseLeave={ (e) => { this._player_volume_onMouseLeave( e, 'Box' ) } }
                         />
                      </div>
                    )
                  }
                  { ! this.state.muted
                    ?
                      <button
                        className={ `${alias}videocontrols-btn btn-volume-ok` }
                        onClick={ ( e ) => { this._player_mute( e ) } }
                        onMouseEnter={ (e) => { this._player_volume_onMouseEnter( e, 'Btn' ) } }
                        onMouseLeave={ (e) => { this._player_volume_onMouseLeave( e, 'Btn' ) } }
                      >
                        <span class="mi-icon mi-icon-volume-low"></span>
                      </button>
                    :
                      <button
                        className={ `${alias}videocontrols-btn btn-volume-mute` }
                        onClick={ ( e ) => { this._player_mute( e ) } }
                        onMouseEnter={ (e) => { this._player_volume_onMouseEnter( e, 'Btn' ) } }
                        onMouseLeave={ (e) => { this._player_volume_onMouseLeave( e, 'Btn' ) } }
                      >
                        <span class="mi-icon mi-icon-volume-mute2"></span>
                      </button>
                  }


                { this._get_option('playlistShowBtnFullScreen')
                  ?
                    <FullScreenButton
                      className={ `${alias}videocontrols-btn btn-fullscreen` }
                      element= { document.getElementById( `${alias}video-body` ) }
                      fullscreen={ ( status ) => { this._player_fullscreen( status ) } }
                    >
                      <span class="mi-icon mi-icon-enlarge2"></span>
                    </FullScreenButton>
                  : ''
                }
              </div>
          </div>

          <div className={ `${alias}videocontrols-line2` }>

               { this.state.paused
              ?
                <button
                  className={ `${alias}videocontrols-btn btn-play` }
                  onClick={ ( e ) => { this._player_play( e ) } }
                >
                  <span class="mi-icon mi-icon-play4"></span>
                </button>
              :
                <button
                  className={ `${alias}videocontrols-btn btn-pause` }
                  onClick={ ( e ) => { this._player_play( e ) } }
                >
                  <span class="mi-icon mi-icon-pause2"></span>
                </button>
            }

              <div className={ `${alias}rangebar btn-video-seekbar` }>
                <input
                  type='range'
                  value={ currentTime }
                  min={ 0 }
                  max={ duration }
                  step={ 0.1 }
                  onChange={ ( e ) => { this._player_customTime( e ) } }
                />
              </div>

            <div className={ `${alias}videocontrols-timer` }>
              <span>{ this._toHHMMSS( currentTime ) }</span>
            </div>
          </div>

        </div>



        {/* Video */}
        <div className={ `${alias}video-body` } id={ `${alias}video-body` } >
          <video
            preload="metadata"
            id={ `${this.player_id}` }
            key={ videoid }
            width="auto"
            height="588"
          >
            <source src={ video_url } type="video/mp4" />
          </video>
        </div>
        {/* end Video */}

      </React.Fragment>
    );
  }

  _player_get_duration()
  {
    const player = document.getElementById( this.player_id );
    if ( ! player ) {
      return false;
    }

    let duration = player.duration;
    duration = Number.isNaN(duration) ? null : duration.toFixed();

    this.setState({
      duration: duration,
    });

    if ( parseInt(this.state.currentTime) === parseInt(this.state.duration) ) {
      this.setState({
        paused: true
      });
      clearInterval( this.play_timer );
    }

    return duration;
  }

  _player_get_currentTime()
  {
    const player = document.getElementById( this.player_id );
    if ( ! player ) {
      return false;
    }

    let currentTime = player.currentTime;
    currentTime = Number.isNaN(currentTime) ? null : currentTime.toFixed();

    this.setState({
      currentTime: currentTime,
    });

    if ( parseInt(this.state.currentTime) === parseInt(this.state.duration) ) {
      this.setState({
        paused: true
      });
      clearInterval( this.play_timer );
    }

    return currentTime;
  }

  _videobox_handleHover( event )
  {
    this.setState({
      videobox_isHovered: ! this.state.videobox_isHovered
    });
  }

  _player_customTime( event )
  {
    const player = document.getElementById( this.player_id );
    const time_range = document.querySelector(".btn-video-seekbar > input[type='range']"),
          value = time_range.value;

    player.currentTime = value;

    this.setVideoTime( 'currentTime' );
  }

  _player_rewind( event )
  {
    const player = document.getElementById( this.player_id );
    const time_range = document.querySelector(".btn-video-seekbar > input");

    player.currentTime = 0;

    this.setVideoTime( 'currentTime' );
  }

  _player_play( event )
  {
    const player = document.getElementById( this.player_id );

    this.setState({
      paused: !this.state.paused
    });

    if ( this.state.paused === true ) {
      player.play();

      this.setState({
        paused: false
      });

      this.play_timer = setInterval( () => this.setState({
        currentTime: this._player_get_currentTime()
      }), 10 );
    }
    else {
      player.pause();

      this.setState({
        paused: true
      });

      clearInterval( this.play_timer );
    }
  }

  _player_mute()
  {
    const player = document.getElementById( this.player_id );
    player.muted = true;

    this.setState({
      muted: true
    });

    if ( this.state.muted === true ) {
      player.muted = false;

      this.setState({
        muted: false
      });
    }
    else {
      player.muted = true;

      this.setState({
        muted: true
      });
    }
  }

  _player_customVolume()
  {
    const player = document.getElementById( this.player_id );
    const volume_range = document.querySelector(".btn-volume-seekbar > input[type='range']"),
          value = volume_range.value;

    player.volume = value;

    this.setState({
      volume: value,
    });

    if ( value <= 0 ) {
      this.setState({
        muted: true
      });
    }
    else {
      this.setState({
        muted: false
      });
    }
  }

  _player_volume_onMouseEnter( event, elem )
  {
    let what = `volumeOpen${elem}`;
    this.setState({[what]: true});
  }

  _player_volume_onMouseLeave( event, elem )
  {
    let what = `volumeOpen${elem}`;
    setTimeout( () => { this.setState({[what]: false}) }, 250 );
  }

  _player_fullscreen( status )
  {
    this.setState({ fullscreen: status });

    if ( status ) {
      document.querySelector(`.${alias}videocontrols`).classList.add("isFullscreen");
    }
    else {
      document.querySelector(`.${alias}videocontrols`).classList.remove("isFullscreen");
    }
  }

  _player_nextprev( event, what )
  {

    let { current_videoid } = this.props.extra;

    let new_videoid = this._get_nextprev_video( what );

    this.setVideoTime( 'duration' );
    this.setVideoTime( 'currentTime' );

    this.setState({
      paused: true,
    });
    clearInterval( this.play_timer );
    this.props.PlSingleItem_onClick( { videoid: new_videoid } );

    this.scrollElement.scrollTop = this._calcListOffset_nextprev( what );
  }

  //============================================================================================
  // MISC
  _get_option( opt_name )
  {
    let options = this.props.options;

    let opt = null;
    if ( InstabergUtils.isset( options, opt_name ) ) {
      opt = options[ opt_name ];
    }
    return opt;
  }

  _get_videos()
  {
    let { videos } = this.props;
    return videos;
  }

  _has_videos()
  {
    let videos = this._get_videos();
    return videos.length;
  }

  _get_video_key_byid( videoid )
  {
    let videos = this._get_videos();

    return InstabergUtils.Video_In_List_GetKey( videos, { id: videoid } );
  }

  _get_video_info_byid( videoid )
  {
    let videos = this._get_videos();

    return InstabergUtils.get_video_details( videos, videoid );
  }

  _toHHMMSS( str )
  {
    let sec_num = parseInt( str, 10);
    if ( Number.isNaN(sec_num) ) {
      sec_num = 0;
      return '00:00';
    }

    let hours = Math.floor( sec_num / 3600 ),
        minutes = Math.floor( (sec_num - hours * 3600) / 60 ),
        seconds = sec_num - hours * 3600 - minutes * 60;

    if ( hours < 10 ) {
      hours = '0' + hours;
    }
    if ( minutes < 10 ) {
      minutes = '0' + minutes;
    }
    if ( seconds < 10 ) {
      seconds = '0' + seconds;
    }

    let ret = hours + ":" + minutes + ":" + seconds;
    if ( hours <=0 ) {
      ret = minutes + ":" + seconds;
    }
    return ret;
  }

  _get_nextprev_video( what='' )
  {
    let videos = this._get_videos();
    let idx = this._get_nextprev_video_idx( what );

    return videos[ idx ].id;
  }

  _is_firstlast_video()
  {
    let videos = this._get_videos();
    let { 0: video_first, length: videos_len, [videos_len-1]: video_last } = videos;

    let ret = '';

    if ( video_first.id === current_videoid )
    {
      ret = 'first';
    }
    if ( video_last.id === current_videoid )
    {
      ret = 'last';
    }

    return ret;
  }

  _get_nextprev_video_idx( what='' )
  {
    let videos = this._get_videos();
    let { 0: video_first, length: videos_len, [videos_len-1]: video_last } = videos;

    let { current_videoid } = this.props.extra;

    let what_allowed = ['prev', 'next'];
    let ret = {
      next: 0,
      prev: 0,
    };

    if ( videos_len <= 1 )
    {
      return what_allowed.includes( what ) ? ret[ what ] : ret;
    }

    if ( video_first.id === current_videoid )
    {
      ret['next'] = 1;
      ret['prev'] = videos_len - 1; // cycle to last item
      return what_allowed.includes( what ) ? ret[ what ] : ret;
    }

    if ( video_last.id === current_videoid )
    {
      ret['prev'] = videos_len - 2;
      ret['next'] = 0; // cycle to first item
      return what_allowed.includes( what ) ? ret[ what ] : ret;
    }

    let found = InstabergUtils.Video_In_List_GetKey( videos, { id: current_videoid } );

    ret['next'] = found + 1;
    ret['prev'] = found - 1;

    return what_allowed.includes( what ) ? ret[ what ] : ret;
  }

  _is_nextprev_needed()
  {
    if ( this._has_videos() <= 1 ) {
      return false;
    }
    return true;
  }

  _calcListOffset_lbx()
  {
    let videos = this._get_videos();
    let { current_videoid } = this.props.extra;

    const height = this.listItemHeight;
    let found_key = InstabergUtils.Video_In_List_GetKey( videos, { id: current_videoid } );
    return found_key ? parseInt( found_key * height ) : 0;
  }

  _calcListOffset_nextprev( what )
  {
    let videos = this._get_videos();
    let { 0: video_first, length: videos_len, [videos_len-1]: video_last } = videos;

    let { current_videoid } = this.props.extra;

    if ( videos_len <= 1 ) {
      return 0;
    }

    let position = '';
    if ( video_first.id === current_videoid )
    {
      position = 'first';
    }
    else if ( video_last.id === current_videoid )
    {
      position = 'last';
    }

    if ( 'first' === position && 'prev' === what ) {
      return parseInt( this.listItemHeight * ( videos_len - 1 ) );
    }
    if ( 'last' === position && 'next' === what ) {
      return 0;
    }

    let offset = 'prev' === what ? -this.listItemHeight : this.listItemHeight;
    return this.scrollElement.scrollTop + offset;
  }

}
export { InstabergViewPlaylist };



// WEBPACK FOOTER //
// ./wp-content/plugins/instaberg/src/templates/playlist/tpl.view.js